import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  loginRequest,
  loginSuccess,
  loginFailure,
  fetchSessionRequest,
  fetchSessionSuccess,
  fetchSessionFailure,
  logout,
  registerSuccess,
  registerFailure,
  registerRequest,
} from "./userActions";
import userService from "../../../services/api.services/user/userService";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";
import {
  hydrateWalletFromLogin,
  fetchWalletRequest,
  clearWallet,
} from "store/wallet/walletActions";
import {
  LoginSuccessDto,
  RegisterRequestDto,
  RegisterSuccessDto,
} from "services/api.services/user/userServiceType";
import { ServiceCallResult } from "services/api.services/cashQuinHttpResponse/cashQuinHttpResponse";

function* handleLogin(
  action: ReturnType<typeof loginRequest>,
): Generator<any, void, any> {
  try {
    const result: ServiceCallResult<LoginSuccessDto> = yield call(
      userService.login,
      action.payload,
    );

    if (!result.ok) {
      // validation errors me nicer msg (optional)
      const firstFieldError = result.errors
        ? Object.values(result.errors).flat()[0]
        : null;

      yield put(
        loginFailure(firstFieldError || result.message || "Login failed"),
      );
      yield put(clearWallet());
      return;
    }

    const session = result.value;

    yield put(loginSuccess(session));

    // wallet hydrate + fetch
    if (session.walletInfo && session.userId) {
      yield put(
        hydrateWalletFromLogin({
          userId: session.userId,
          walletInfo: session.walletInfo,
        }),
      );
      yield put(fetchWalletRequest({ userId: session.userId, force: true }));
    } else {
      yield put(clearWallet());
    }
  } catch (error: any) {
    const err = error as NormalizedError;

    let uiMsg = "Login failed";
    if (err?.isNetwork)
      uiMsg = "Internal server error. Please try again after some time.";
    else if (err?.status === 401) uiMsg = "Invalid credentials.";
    else if (err?.status >= 500) uiMsg = "Server error. Please try again.";

    // Agar backend 400 validation ke saath aaya hai aur tumhare NormalizedError me raw.data hai:
    const raw = (err as any)?.raw?.data;
    if (raw?.message) uiMsg = raw.message;

    // Field error preference (e.g. passwordHash)
    const pwdErrors = raw?.errors?.passwordHash;
    if (Array.isArray(pwdErrors) && pwdErrors[0]) uiMsg = pwdErrors[0];

    yield put(loginFailure(uiMsg));
    yield put(clearWallet());
  }
}

function* handleRegister(
  action: ReturnType<typeof registerRequest>,
): Generator<any, void, any> {
  try {
    const payload: RegisterRequestDto = action.payload;
    const result: ServiceCallResult<RegisterSuccessDto> = yield call(
      userService.register,
      payload,
    );

    if (!result.ok) {
      const firstFieldError = result.errors
        ? Object.values(result.errors).flat()[0]
        : null;

      yield put(
        registerFailure(
          firstFieldError || result.message || "Registration failed",
        ),
      );
      return;
    }

    yield put(registerSuccess(result.value));
  } catch (error: any) {
    const err = error as NormalizedError;
    let uiMsg = "Registration failed";

    if (err?.isNetwork)
      uiMsg = "Internal server error. Please try again after some time.";
    else if (err?.status === 400)
      uiMsg = err?.message || "Invalid details. Please check your inputs.";
    else if (err?.status === 409)
      uiMsg = err?.message || "User already exists.";
    else if (err?.status >= 500) uiMsg = "Server error. Please try again.";

    const raw = (err as any)?.raw?.data;
    if (raw?.message) uiMsg = raw.message;

    yield put(registerFailure(uiMsg));
  }
}

// Worker Saga: fetch session
function* handleFetchSession(): Generator<any, void, any> {
  try {
    const data = yield call(userService.fetchSession);
    yield put(fetchSessionSuccess(data));
  } catch (error: any) {
    yield put(fetchSessionFailure(error.message || "Session fetch failed"));
    // yield put(logout());
  }
}

// Worker Saga: logout
function* handleLogout(): Generator<any, void, any> {
  try {
    yield call(userService.logout);
  } catch {
    // ignore errors on logout
  }
}

export default function* userSaga() {
  yield all([
    takeLatest(loginRequest.type, handleLogin),
    takeLatest(registerRequest.type, handleRegister),
    takeLatest(fetchSessionRequest.type, handleFetchSession),
    takeLatest(logout.type, handleLogout),
  ]);
}

// import { all, call, put, takeLatest } from "redux-saga/effects";
// import {
//   loginRequest,
//   loginSuccess,
//   loginFailure,
//   fetchSessionRequest,
//   fetchSessionSuccess,
//   fetchSessionFailure,
//   logout,
//   registerSuccess,
//   registerFailure,
//   registerRequest,
// } from "./userActions";
// import userService from "../../../services/api.services/user/userService";
// import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";
// import { hydrateWalletFromLogin, fetchWalletRequest } from "store/wallet/walletActions";
// import { RegisterPayload } from "services/api.services/user/userServiceType";

// function* handleLogin(
//   action: ReturnType<typeof loginRequest>
// ): Generator<any, void, any> {
//   try {
//     const data = yield call(userService.login, action.payload);
//     // console.log("saga-----data  ", data);

//     if (!data?.token) {
//       yield put(loginFailure("Login failed"));
//     } else {
//       // 1) user reducer
//       yield put(loginSuccess(data));

//       // 2) wallet ko login response se hydrate
//       if (data?.walletInfo && data?.userId) {
//         yield put(
//           hydrateWalletFromLogin({
//             userId: data.userId,
//             walletInfo: data.walletInfo,
//           })
//         );

//         // 3) userId se wallet summary / transactions fetch
//         yield put(
//           fetchWalletRequest({
//             userId: data.userId,
//             force: true,
//           })
//         );
//       }
//     }
//     // yield put(loginSuccess(data));
//   } catch (error: any) {
//     // console.log({error});

//     const err = error as NormalizedError;

//     // console.log({err});

//     // Friendly UI message
//     let uiMsg = "Login failed";
//     if (err?.isNetwork)
//       uiMsg = "Internal server error. Please try again after some time.";
//     // else if (err.isTimeout) uiMsg = "server took too long to respond. Please try again.";
//     else if (err?.status === 401) uiMsg = "Invalid credentials.";
//     else if (err?.status >= 500) uiMsg = "Server error. Please try again.";

//     yield put(loginFailure(uiMsg));
//     // yield put(loginFailure(error.message || "Login failed"));
//   }
// }

// // Register saga
// function* handleRegister(
//   action: ReturnType<typeof registerRequest>
// ): Generator<any, void, any> {
//   try {
//     const payload: RegisterPayload = action.payload;

//     const data = yield call(userService.register, payload);

//     if(!data.status || data.statusCode === "409"){
//       yield put(registerFailure(data.message));
//       return;
//     }

//     yield put(registerSuccess(data));

//   } catch (error: any) {
//     const err = error as NormalizedError;

//     // console.log({err});

//      let uiMsg = err?.raw?.message || "Registration failed";
//     if (err?.isNetwork)
//       uiMsg = "Internal server error. Please try again after some time.";
//     else if (err?.status === 400)
//       uiMsg = err?.message || "Invalid details. Please check your inputs.";
//     else if (err?.status === 409)
//       uiMsg = err?.message || "User already exists.";
//     else if (err?.status >= 500) uiMsg = "Server error. Please try again.";

//     yield put(registerFailure(uiMsg));
//   }
// }

// // Worker Saga: fetch session
// function* handleFetchSession(): Generator<any, void, any> {
//   try {
//     const data = yield call(userService.fetchSession);
//     yield put(fetchSessionSuccess(data));
//   } catch (error: any) {
//     yield put(fetchSessionFailure(error.message || "Session fetch failed"));
//     // yield put(logout());
//   }
// }

// // Worker Saga: logout
// function* handleLogout(): Generator<any, void, any> {
//   try {
//     yield call(userService.logout);
//   } catch {
//     // ignore errors on logout
//   }
// }

// export default function* userSaga() {
//   yield all([
//     // fork(authInit),
//     takeLatest(loginRequest.type, handleLogin),
//     takeLatest(fetchSessionRequest.type, handleFetchSession),
//     takeLatest(logout.type, handleLogout),
//     takeLatest(registerRequest.type, handleRegister),
//   ]);
// }
